import React from "react";

import styled from "styled-components";
import { color, fontSize } from "style/constants";
import { formatDate, formatDateToNow } from "utils/date";
import { differenceInHours } from "date-fns";
import { Box } from "@material-ui/core";

const SecondaryText = styled.div`
  && {
    color: ${color.LIGHTGRAY};
    font-size: ${fontSize.small};
    white-space: normal;
    overflow: hidden;
  }
`;

interface SessionTimeProps {
  type: "last" | "next" | "updated";
  timeStamp: string;
  coach?: string;
}

const SessionTime: React.FC<SessionTimeProps> = ({
  type,
  timeStamp,
  coach
}: SessionTimeProps): JSX.Element => {
  const getAge = (date: string): JSX.Element => {
    const hours = differenceInHours(new Date(), new Date(date));

    if (hours < 1) {
      return <span>&lt; 1 hour</span>;
    } else if (hours < 24) {
      return <span>&lt; 1 day</span>;
    } else if (hours < 24 * 10) {
      return <span>{`${Math.floor(hours / 24)} days`}</span>;
    } else {
      return <span>{`${Math.floor(hours / 24)} days`}</span>;
    }
  };
  if (type === "updated") {
    return (
      <>
        <div>{getAge(timeStamp)}</div>
        <SecondaryText>{formatDate(timeStamp, "MM/dd/yyyy")}</SecondaryText>
      </>
    );
  } else if (type === "last") {
    return (
      <>
        <div>{formatDate(timeStamp, "MM/dd/yyyy")}</div>
        <SecondaryText>Coach: {coach || "N/A"}</SecondaryText>
      </>
    );
  } else if (type === "next") {
    return (
      <>
        <div>{formatDate(timeStamp, "MM/dd/yyyy")}</div>
        <SecondaryText>Coach: {coach || "N/A"}</SecondaryText>
      </>
    );
  } else {
    return <div>N/A</div>;
  }
};

export default SessionTime;
